import DFPager from "app/widgets/DFPager/DFPager";
import locale from "common/managers/locale";
export default {

    _cleanupPageable: function() {
        if (this.customPager && this.customPager.element) {
            this.customPager.destroy();
            delete this.customPager;
        }
        if (this.customPagerElement) {
            this.customPagerElement.remove();
            delete this.customPagerElement;
        }
    },

    _pageable: function() {
        if (this.options.pager) {
            if (this.customPager) {
                this.customPager.destroy();
            }
            if (!this.customPagerElement) {
                this.customPagerElement = $("<div>")
                    .attr("id", this.element.attr("id") + "_pager")
                    .addClass("flexRight")
                    .toggleClass("showCount", this.options.showPagerTotal)
                    .toggleClass("fixed", this.element.hasClass("shrinkAndScroll"))
                    [this.options.pager !== "after" ? "insertBefore" : "insertAfter"](this.wrapper);
            }
            this.customPager = new DFPager(this.customPagerElement, {
                dataSource: this.dataSource,
                defaultPaging: this.options.defaultPaging
            });
        } else {

            // set up our default options for paging
            if (this.options.defaultPaging == true) {
                this.options.pageable = {
                    input: true,
                    numeric: false,
                    responsive: false,
                    messages: {
                        display: locale.get(this.options.pagerDisplayKey) + '{2}',
                        itemsPerPage: locale.get('pager.itemsPerPage'),
                        page: locale.get('pager.page'),
                        empty: locale.get('pager.total') + '0'
                    }
                };
            }

            // set up imprecise messages
            if (this.options.impreciseCount) {
                this.options.pageable.messages.of = "";
            }

            kendo.ui.Grid.fn._pageable.apply(this, arguments);

            // add imprecise style
            if (this.options.impreciseCount) {
                this.pager.element.addClass("imprecise-count-pager");
            }
        }
    },

    _updatePager: function() {

        // update imprecise pager display
        if (this.options.impreciseCount && this.pager) {
            var pagerOptions = this.pager.options;
            pagerOptions.messages.display = (this.dataSource.page() == this.dataSource.totalPages()) ? locale.get("pager.display.precise") : locale.get("pager.display.imprecise");
            this.pager.setOptions(pagerOptions);
        }

        if (!this.customPager && this.options.pageable) {
            if (this.dataSource.totalPages() > 1) {
                this.element.find(".k-grid-pager").removeClass("onePage");
                // FIXME removing the tabindex does not work due to the pager refreshing after the grid
                //.find(".k-pager-nav:not(.k-state-disabled)").removeAttr("tabindex");
                return;
            }
            if (!this.options.alwaysShowPager) {
                this.element.find(".k-grid-pager").addClass("onePage");
            }
        }
    }
};
